import { render, staticRenderFns } from "./ProductFormLayout.vue?vue&type=template&id=6b5bbbd8&"
import script from "./ProductFormLayout.vue?vue&type=script&lang=js&"
export * from "./ProductFormLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports